import { createTheme } from '@mui/material/styles';
import { brandColors } from '@config/brandTokens';

/**
 * Material-UI theme — EncycGames brand system
 * @see docs/BRAND_GUIDELINES_ENYCGAMES.md
 */
const theme = createTheme({
  palette: {
    primary: {
      main: brandColors.navy,
      light: brandColors.blue,
      dark: '#0a0f28',
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.blue,
      light: '#7a93f0',
      dark: '#3a56c9',
      contrastText: brandColors.white,
    },
    success: {
      main: brandColors.green,
      light: '#6fd04a',
      dark: '#3a8a1a',
    },
    error: {
      main: '#d32f2f',
      light: '#ef5350',
      dark: '#c62828',
    },
    warning: {
      main: brandColors.orange,
      light: '#f07a3d',
      dark: '#c44609',
    },
    info: {
      main: brandColors.blue,
      light: '#7a93f0',
      dark: '#3a56c9',
    },
    background: {
      default: brandColors.ice,
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.slate,
      secondary: '#64748b',
    },
  },
  typography: {
    fontFamily: ['"Inter"', 'Arial', 'sans-serif'].join(','),
    h1: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '2rem',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '1.75rem',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Sora", Arial, sans-serif',
      fontSize: '1rem',
      fontWeight: 600,
    },
    button: {
      fontFamily: '"Inter", Arial, sans-serif',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
});

export default theme;
